import React, { ReactNode } from "react";

export interface BusinessModuleData {
	tradingname: string;
	// businessemail: string;
	country: string;
	merchantaccounttype: string;
	merchantcode: string;
	status: React.ReactNode;
	createdat: string;
	islive: React.ReactNode;
	id: number;
}

export const ColumnBusinessModule = [
	{
		Header: "Business name",
		accessor: "tradingname",
	},
	// {
	//   Header: "Email Address",
	//   accessor: "businessemail"
	// },
	{
		Header: "Business Type",
		accessor: "merchantaccounttype",
	},
	{
		Header: "Country",
		accessor: "country",
	},
	{
		Header: "Merchant code",
		accessor: "merchantcode",
	},
	{
		Header: "Status",
		accessor: "status",
	},
	{
		Header: "Env",
		accessor: "islive",
	},
	{
		Header: "Date",
		accessor: "createdat",
	},
];

export interface BusinessUserModuleData {
	firstname: string;
	lastname: string;
	email: string;
	bvn: string;
	phonenumber: string;
	country: string;
}

export const ColumnBusinessUserModule = [
	{
		Header: "First Name",
		accessor: "firstname",
	},
	{
		Header: "Last Name",
		accessor: "lastname",
	},
	{
		Header: "Email Address",
		accessor: "email",
	},
	{
		Header: "Phone Number",
		accessor: "phonenumber",
	},
	{
		Header: "Country",
		accessor: "country",
	},
];

export interface BusinessCustomerModuleData {
	firstname: string;
	email: string;
	msisdn: string;
	phonenumber: string;
	country: string;
	isblacklisted: React.ReactNode;
	createdat: string;
}

export const ColumnBusinessCustomerModule = [
	{
		Header: "First Name",
		accessor: "firstname",
	},
	{
		Header: "Email Address",
		accessor: "email",
	},
	{
		Header: "Phone Number",
		accessor: "phonenumber",
	},
	{
		Header: "Country",
		accessor: "country",
	},
	{
		Header: "Blacklisted",
		accessor: "isblacklisted",
	},
	{
		Header: "Blacklist Reason",
		accessor: "blacklistreason",
	},

	{
		Header: "msisdn",
		accessor: "msisdn",
	},
];

export interface BusinessTransactionModuleData {
	tradingname: any;
	amount: string;
	linkingreference: string;
	chargetype: string;
	responsemessage: string;
	timein: string;
	businessemail: string;
}

export const ColumnBusinessTransactionModule = [
	{
		Header: "Trading name",
		accessor: "tradingname",
	},
	{
		Header: "Email address",
		accessor: "businessemail",
	},
	{
		Header: "Transaction amount",
		accessor: "amount",
	},
	{
		Header: "Reference",
		accessor: "linkingreference",
	},
	{
		Header: "Charge Type",
		accessor: "chargetype",
	},
	// {
	// 	Header: "Response Message",
	// 	accessor: "responsemessage",
	// },

	{
		Header: "Time In",
		accessor: "timein",
	},
];

export interface BusinessLimitModuleData {
	category: any;
	transactiontype: string;
	auth: string;
	limit: string;
	min: string;
	max: string;
	status: React.ReactNode;
	createdat: string;
	timein: string;
	payment: string;
	transactionlocale: string;
	limitId: number;
}

export const ColumnBusinessLimitModule = [
	// {
	// 	Header: "Category",
	// 	accessor: "category",
	// },
	{
		Header: "Transaction Type",
		accessor: "transactiontype",
	},

	{
		Header: "Payment Method",
		accessor: "payment",
	},
	{
		Header: "Locale",
		accessor: "transactionlocale",
	},
	// {
	//   Header: "Cum. transaction limit",
	//   accessor: "limit"
	// },
	// {
	//   Header: "Min Limit",
	//   accessor: "min"
	// },
	// {
	//   Header: "Min Limit",
	//   accessor: "max"
	// },
	{
		Header: "Status",
		accessor: "status",
	},
	{
		Header: "Created At",
		accessor: "createdat",
	},

	{
		Header: "Time Approved",
		accessor: "timein",
	},
];

export interface BusinessFeeModuleData {
	category: any;
	feeType: string;
	transactiontype: string;
	auth: string;
	fee: string;
	feeSettingValue: string;
	min: string;
	max: string;
	status: React.ReactNode;
	createdat: string;
	timein: string;
	payment: string;
	transactionlocale?: string;
	cumulativeTransactionLimit?: string;
	id?: number;
}

export const ColumnBusinessFeeModule = [
	// {
	// 	Header: "Category",
	// 	accessor: "category",
	// },
	{
		Header: "Transaction Type",
		accessor: "transactiontype",
	},
	{
		Header: "Payment Method",
		accessor: "payment",
	},
	{
		Header: "Locale",
		accessor: "transactionlocale",
	},
	{
		Header: "Fee Setting",
		accessor: "fee",
	},
	// {
	//   Header: "Fee Min",
	//   accessor: "min"
	// },
	// {
	//   Header: "Fee Cap",
	//   accessor: "max"
	// },
	{
		Header: "Status",
		accessor: "status",
	},
	{
		Header: "Created At",
		accessor: "createdat",
	},

	{
		Header: "Time Approved",
		accessor: "timein",
	},
];

export interface BusinessScheduleModuleData {
	category: any;
	transactiontype: string;
	auth: string;
	fee: string;
	min: string;
	max: string;
	bear: string;
	status: React.ReactNode;
	createdat: string;
	timein: string;
}

export const ColumnBusinessScheduleModule = [
	{
		Header: "Category",
		accessor: "category",
	},
	{
		Header: "Transaction Type",
		accessor: "transactiontype",
	},
	{
		Header: "Auth Option",
		accessor: "auth",
	},
	{
		Header: "Fee Setting",
		accessor: "fee",
	},
	{
		Header: "Fee Min",
		accessor: "min",
	},
	{
		Header: "Fee Cap",
		accessor: "max",
	},
	{
		Header: "Merchant has bearer",
		accessor: "bear",
	},
	{
		Header: "Status",
		accessor: "status",
	},
	{
		Header: "Created At",
		accessor: "createdat",
	},

	{
		Header: "Time Approved",
		accessor: "timein",
	},
];

export interface BusinessSettlementScheduleData {
	merchantaccountid: any;
	periodsetting: string;
	periodsettingvalue: string;
	status: React.ReactNode;
	createdat: string;
	locale: string;
	id: string | number;
}

export const ColumnBusinessSettlementScheduleData = [
	{
		Header: "Merchant ID",
		accessor: "merchantaccountid",
	},
	{
		Header: "Period Setting",
		accessor: "periodsetting",
	},
	{
		Header: "Period Value",
		accessor: "periodsettingvalue",
	},
	{
		Header: "Status",
		accessor: "status",
	},
	{
		Header: "Locale",
		accessor: "locale",
	},

	{
		Header: "Created At",
		accessor: "createdat",
	},
];

export interface BusinessRollingReserveData {
	rolling_id: number;
	settlement_id: string;
	amount: string;
	currency: string;
	status: number;
	statusView: ReactNode | string;
	merchantcode: string;
	balanceBefore: string;
	balanceAfter: string;
	duedate: string;
	dateCreated: string;
}

export const ColumnRollingReserveData = [
	{
		Header: "Reserve Amount",
		accessor: "amount",
	},
	{
		Header: "Balance before",
		accessor: "balanceBefore",
	},
	{
		Header: "Balance after",
		accessor: "balanceAfter",
	},
	{
		Header: "Status",
		accessor: "statusView",
	},
	{
		Header: "Created Date",
		accessor: "dateCreated",
	},
	{
		Header: "Due date",
		accessor: "duedate",
	},
];

export interface BusinessPaymentProperty {
	rolling_id: number;
	settlement_id: string;
	amount: string;
	currency: string;
	status: number;
	merchantcode: string;
	balanceBefore: string;
	balanceAfter: string;
	duedate: string;
	date: string;
}

export const ColumnPaymentProperty = [
	{
		Header: "settlement ID",
		accessor: "settlement_id",
	},
	{
		Header: "Currency",
		accessor: "currency",
	},
	{
		Header: "Amount",
		accessor: "amount",
	},

	{
		Header: "Status",
		accessor: "status",
	},
	{
		Header: "Machant code",
		accessor: "merchantcode",
	},
	{
		Header: "Balance before",
		accessor: "balanceBefore",
	},
	{
		Header: "Balance after",
		accessor: "balanceAfter",
	},
	{
		Header: "Due date",
		accessor: "duedate",
	},
	{
		Header: "Created Date",
		accessor: "date",
	},
];

export interface BusinessMeta {
	merchantaccountmetaid: number;
	name: string;
	value: string;
	createdat: string;
	other: number;
}

export const ColumnMeta = [
	// {
	//   Header: "Merchant Account Meta ID",
	//   accessor: "merchantaccountmetaid"
	// },
	{
		Header: "Name",
		accessor: "name",
	},
	{
		Header: "Value",
		accessor: "value",
	},

	{
		Header: "Created At",
		accessor: "createdat",
	},
	{
		Header: "Other",
		accessor: "other",
	},
];

export interface RecentSettlementModuleData {
	tradingname: string;

	amount: any;

	chargeamount: any;

	fee: any;

	settlementtype: string;

	settlementdate: string;
}

export const ColumnRecentSettlementModule = [
	{
		Header: "Business name",
		accessor: "tradingname",
	},

	{
		Header: "Business type",
		accessor: "settlementtype",
	},

	{
		Header: "Transaction amount",
		accessor: "chargeamount",
	},

	{
		Header: "MSC",
		accessor: "fee",
	},

	{
		Header: "Amount due to merchant",
		accessor: "amount",
	},

	{
		Header: "Settlement date",
		accessor: "settlementdate",
	},
];
